import { RouterProvider } from "react-router-dom";
import "./App.scss";
import { Router } from './routes/route';

function App() {
  return (
    <div className="registrations-app">
      <RouterProvider router={Router} />
    </div>
  );
}

export default App;
